import ImagesModel from "../../../../Global/Models/Images/ImagesModel";
import PreferenceMappingModel from "../../../../Global/Models/PreferenceMapping/PreferenceMappingModel";

export default class PollOptionModel {
  public id: string = null;
  public title: string = null;
  public description: string = null;
  public images: ImagesModel = new ImagesModel();
  public votes: number = null;
  public embedCode: string | null = null;
  public preferencesMapping: PreferenceMappingModel[] = [];
}
